module.exports = __webpack_public_path__ + "static/media/heart-shaped-pendent_720x480.d37cc48c.jpg";